<sync-alert 
        *ngIf="_errCode && _errCode.code"
        [type]="'critical'"
        [showLeadIcon]="true"
        [leadIcon]="'error'"
        [title]="''"
        [description]="((showErrCode ? _errCode.code : '') + ' ' + (_errCode.msg ? _errCode.msg : 'An error occurred.'))"
        [showActions]="false"
        [showPrimaryAction]="false" 
        [showSecondaryAction]="false"
        [showCloseButton]="false"
></sync-alert>